// client/src/utils/env.js
export function readEnv(name) {
  // Vite/webpack@^5 з DefinePlugin для import.meta.env
  if (typeof import.meta !== "undefined" && import.meta.env && name in import.meta.env)
    return import.meta.env[name];

  // Webpack DefinePlugin для process.env
  if (typeof process !== "undefined" && process.env && name in process.env)
    return process.env[name];

  // Глобальне вікно (з index.html)
  if (typeof window !== "undefined" && window.ENV && name in window.ENV)
    return window.ENV[name];

  return null;
}

export function getApiOrigin() {
  const v = readEnv("API_ORIGIN");
  if (v) return v;

  // Дев-фолбек: якщо фронт біжить на localhost, API на 3030
  if (typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return "http://localhost:3030";
  }

  // Прод: same-origin (через nginx/proxy)
  return "";
}
